import React from "react";
import ReactDOM from "react-dom/client";
const App = React.lazy(() => import("./App").then(async (module) => {
  await import("./styles.css");
  return module;
}));
const Website = React.lazy(() => import("./website/Website.jsx"));

function Root() {
  const [hash, setHash] = React.useState(window.location.hash);
  React.useEffect(() => {
    const update = () => setHash(window.location.hash);
    window.addEventListener("hashchange", update);
    return () => window.removeEventListener("hashchange", update);
  }, []);
  const route = hash.split("?")[0];
  return <React.Suspense fallback={null}>{route === "#/site" || route.startsWith("#/site/") ? <Website page={route.slice(7).replace(/\/$/, '') || 'home'} /> : <App />}</React.Suspense>;
}

ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <Root />
  </React.StrictMode>
);
